import React, {Component} from 'react'
import ReCAPTCHA from "react-google-recaptcha";

export default class Captcha extends Component {
    render() {
        return(
            <div>
                <ReCAPTCHA
                    sitekey={"6LcX-SsUAAAAAMuTwXYvAQuioravK_HVJnYtVDrl"}
                    onChange={this.props.input.onChange}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Captcha.js